import React from 'react';
import Options from '@payscale/design/lib/options';
import './style/RadioButtonFacet.scss';
const RadioButtonFacet = (props) => {
    const { facet, selection, facetDistinctItemClick } = props;
    const handleClick = (_optionId, newValue) => {
        facetDistinctItemClick(facet, newValue);
    };
    return (React.createElement(Options, { id: facet.id, options: facet.items.map(i => i.key), type: "radio", value: [selection], onChange: handleClick, multiValue: false, syncOptions: false, className: "radio-button-facet" }));
};
export { RadioButtonFacet };
export default RadioButtonFacet;
